export const chartStorage = new Map<string, any>();
